import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import editTourReducer from '../reducers/editTourReducer';

const configureStore = (railsProps) => (
  createStore(editTourReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
